module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-sidebar-wrapper",
    class: {
      'sidebar-disabled': _vm.disabled
    }
  }, [_c('div', {
    staticClass: "dashboard-sidebar"
  }, [_c('div', {
    staticClass: "sidebar-top"
  }, [_c('div', {
    staticClass: "sidebar-brand"
  }, [_c('div', {
    staticClass: "sidebar-logo"
  }, [_c('img', {
    staticClass: "sidebar-logo-img",
    attrs: {
      "src": _vm.logoShieldIcon,
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-logo-divider"
  })]), _vm._v(" "), _c('nav', {
    staticClass: "sidebar-nav"
  }, [_vm._l((_vm.mainNavItems), function(item) {
    return _c('a', {
      key: item.id,
      class: ['nav-item', {
        active: _vm.currentPath === item.path
      }],
      on: {
        "click": function($event) {
          return _vm.onNavClick(item.path)
        },
        "mouseenter": function($event) {
          return _vm.onNavHover(item)
        }
      }
    }, [(_vm.iconMap[item.id]) ? _c('img', {
      staticClass: "nav-icon-svg",
      attrs: {
        "src": _vm.currentPath === item.path ? _vm.iconMap[item.id].white : _vm.iconMap[item.id].grey,
        "alt": item.label
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "nav-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), (item.badgeCount != null) ? _c('span', {
      class: ['nav-badge', item.badge === 'warning' ? 'warning' : '']
    }, [_vm._v(_vm._s(item.badgeCount))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar-nav-divider"
  }), _vm._v(" "), _c('a', {
    class: ['nav-item', {
      active: _vm.isSettingsActive
    }],
    attrs: {
      "title": "Settings"
    },
    on: {
      "click": function($event) {
        return _vm.onNavClick('/settings')
      }
    }
  }, [_c('img', {
    staticClass: "nav-icon-svg",
    attrs: {
      "src": _vm.isSettingsActive ? _vm.iconMap.settings.white : _vm.iconMap.settings.grey,
      "alt": "Settings"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Settings")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c2aaf1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/DashboardSidebar.vue
// module id = 722
// module chunks = 2